import { useEffect } from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import _ from 'lodash'
import { Row, Col } from 'antd'
import CollapsePanel from '../CollapsePanel/CollapsePanel'
import styles from './Images.css'
import ImageFunctionTable from '../ImageFunctionTable/ImageFunctionTable'
import { EXTRA_MODEL, EXTRA_MODEL_VALUES, UPDATE_LISTING_FORM_KEY } from '../../../../constants/proposalTypes'
import DuplicatedPrefixBlock, {
  getDuplicatedSkuInSpecsList
} from '../../../BatchProposal/Common/PrefixBlock/Duplicated'
import ComplimentariesCollapsePanel from '../ComplimentariesCollapsePanel/ComplimentariesCollapsePanel'
import { adjustImages } from '../helpers/converters'

const EXTRA_MODELS = [
  EXTRA_MODEL.COMPLIMENTARIES,
  EXTRA_MODEL.SELECT_COMPLIMENTARIES,
  EXTRA_MODEL.ADDITIONAL_PURCHASE
]

const Images = props => {
  const {
    readOnly,
    change,
    listing = {},
    proposalType
  } = props
  const {
    id: listingId,
    models = [],
    name: listingName,
    isNoModelsListing,
    syncProductImages,
    shareMediaBetweenModels
  } = listing

  useEffect(() => {
    updateImages(listing)
    // eslint-disable-next-line
  }, [shareMediaBetweenModels])

  const handleOrderImageChange = (e, newImages, prevImages, field) => {
    const form = {
      listing: _.cloneDeep(listing)
    }
    // 圖片剛變更不會立刻反映在 redux form 裡
    // 所以需要從 handler args 取得最新的圖片更新要顯示的商品圖片
    // field: listing.models[x].images
    _.set(form, field, newImages)
    updateImages(form.listing)
  }

  const updateImages = listing => {
    const newListing = adjustImages(listing)
    change('listing', newListing)
  }

  const modelSpecHeader = _.get(models, '[0].spec.name', '')
  const itemSpecHeader = _.get(models, '[0].items[0].spec.name', '')
  const duplicatedSkuInSpecsList = getDuplicatedSkuInSpecsList(models)
  const isDuplicatedSkuExist = !_.isEmpty(duplicatedSkuInSpecsList)
  return (
    <>
      <DuplicatedPrefixBlock
        proposalType={proposalType}
        listing={listing}
        isSingleUpdate
      />
      <CollapsePanel
        panelHeader={(
          <Row
            type='flex'
            align='middle'
            justify='space-between'
            className={styles.panelHeader}
          >
            <Col span={4}>
              賣場編號
              <div className={styles.listingId}>
                {listingId}
              </div>
            </Col>
            <Col span={20}>
              賣場名稱
              <div className={styles.listingName}>
                {listingName}
              </div>
            </Col>
          </Row>
        )}
      >
        <ImageFunctionTable
          hasDistinctSizesUploader
          // 除了預設 readonly 狀態外
          // 萬一雙層賣場中有第二層屬性商品的 sku 重複也禁止修改
          readOnly={readOnly || isDuplicatedSkuExist}
          models={models}
          isNoModelsListing={isNoModelsListing}
          modelsFieldName='listing.models'
          modelSpecHeader={modelSpecHeader}
          itemSpecHeader={itemSpecHeader}
          syncProductImages={syncProductImages}
          shareMediaBetweenModels={shareMediaBetweenModels}
          handleOrderImageChange={handleOrderImageChange}
        />
      </CollapsePanel>
      {/* 贈品&加價購 */}
      {
        _.map(EXTRA_MODELS, property => {
          const {
            title,
            subTitle,
            value
          } = property

          const extraModels = props[value]
          if (!_.isEmpty(extraModels)) {
            const modelsFieldName = `listing.${value}`

            return (
              <ComplimentariesCollapsePanel
                key={modelsFieldName}
                readOnly={readOnly}
                title={title}
                subTitle={subTitle}
                modelsFieldName={modelsFieldName}
                modelSpecHeader='商品名稱'
                models={extraModels}
              />
            )
          } else {
            return null
          }
        })
      }
    </>
  )
}

const selector = formValueSelector(UPDATE_LISTING_FORM_KEY)
const ImagesWithReduxForm = connect(state => {
  const extraModelSelector = EXTRA_MODEL_VALUES.reduce(
    (acc, cur) => ({
      ...acc,
      [cur]: selector(state, `listing.${cur}`)
    })
    , {})

  return ({
    listing: selector(state, 'listing'),
    ...extraModelSelector
  })
})(Images)

export default ImagesWithReduxForm
